export default [
  {
    path: "/region",
    name: "region",
    component: () => import("@/views/region/Region.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/region/edit/:id",
    name: "edit-region",
    component: () => import("@/views/region/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/township-group",
    name: "township-group",
    component: () => import("@/views/township-group/TownshipGroup.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/township-group/edit/:id",
    name: "edit-township-group",
    component: () => import("@/views/township-group/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },

  {
    path: "/outside_township/:township_id",
    name: "outside-township",
    component: () => import("@/views/outsideTownship/OutsideTownship.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/edit-outside_township/:id",
    name: "edit-outside-township",
    component: () => import("@/views/outsideTownship/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/township",
    name: "township",
    component: () => import("@/views/township/Township.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/township/add",
    name: "create-township",
    component: () => import("@/views/township/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/township/edit/:id",
    name: "edit-township",
    component: () => import("@/views/township/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/initial-data/",
    component: () => import("@/views/initial-data/Types.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/sympton",
    name: "sympton",
    component: () => import("@/views/sympton/Sympton.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/sympton/edit/:id",
    name: "edit-sympton",
    component: () => import("@/views/sympton/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/risk_factor",
    name: "risk-factor",
    component: () => import("@/views/risk-factor/RiskFactor.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/risk_factor/edit/:id",
    name: "edit-risk-factor",
    component: () => import("@/views/risk-factor/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/side_effect",
    name: "side-effect",
    component: () => import("@/views/side-effect/SideEffect.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/side_effect/edit/:id",
    name: "edit-side-effect",
    component: () => import("@/views/side-effect/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/procedure",
    name: "procedure",
    component: () => import("@/views/procedure/Procedure.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/procedure/edit/:id",
    name: "edit-procedure",
    component: () => import("@/views/procedure/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
];
